import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserDetail } from '@classes/user-detail';
import { AuthService } from 'app/core/authentication/auth.service';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm!: FormGroup;
  hide = true;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private fb: FormBuilder,
    private authSrv: AuthService,
    public uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data: UserDetail
  ) { }

  ngOnInit() {
    this.initForm();
  }

  private initForm(): void {
    this.changePasswordForm = this.fb.group({
      newPassword: new FormControl(null, [Validators.required]),
    });
  }
  onSubmit(): void {
    if (this.changePasswordForm.valid) {
      this.uiService.addRouteLoading();
      this.authSrv.changePassword(this.changePasswordForm.value.newPassword).subscribe((success) => {
        this.dialogRef.close(true);
      }, (error) => {
        console.error(error);
      }, () => {
        this.uiService.removeRouteLoading();
      });
    }
  }
}
